// Static catalogue for Organo Mushroom Research & Training Center.

const SPAWN_BENEFITS = [
  "Best Quality Oyster Mushroom Spawn",
  "High Shelf-Life",
  "High Yielding",
  "Fast Mycelium Growth",
  "No Bacterial Contamination",
  "Produced in Sterile Condition",
];

// Tiered pricing helper for spawn (per kg)
function spawnPricing(basePrice) {
  return [
    { range: "1 to 5 kg", price: basePrice, unit: "per kg" },
    { range: "5 to 10 kg", price: basePrice - 50, unit: "per kg" },
    { range: "50 to 100 kg", price: basePrice - 80, unit: "per kg" },
  ];
}

export const PRODUCTS = [
  // ===== Mushroom Cultivation =====
  {
    id: "cultivation-kit-10bag",
    name: "Cultivation Kit (10 Bags)",
    full_name: "Mushroom Cultivation Kit · 10 Bags",
    weight: "Kit for 10 bags",
    price: 2000,
    mrp: 2400,
    rating: 4.9,
    reviewCount: 124,
    category: "Mushroom Cultivation",
    storage: "Keep at 22–28°C in indirect light. Use spawn within a week of receiving.",
    image: "/img/cultivation/kit.png",
    tag: "Complete kit",
    description:
      "Mushroom Cultivation kit for 10 bags with all material — white oyster mushroom spawn 1 kg, Pasteurization Powder, P.P. Bags, Hand Gloves, Head Cap, Cotton & Rubber Bands. Everything you need to start your first cultivation cycle.",
    bullets: [
      "1 kg White Oyster mushroom spawn",
      "Pasteurization Powder",
      "10 × P.P. cultivation bags",
      "Hand gloves & head cap",
      "Cotton & rubber bands",
    ],
  },
  {
    id: "pasteurization-powder",
    name: "Pasteurization Powder 1 kg",
    full_name: "Mushroom Pasteurization Powder · 1 kg",
    weight: "1 kg pouch",
    price: 380,
    mrp: 450,
    rating: 4.7,
    reviewCount: 38,
    category: "Mushroom Cultivation",
    storage: "Store in a cool, dry place away from direct sunlight.",
    image: "/img/cultivation/pasteurization-powder.png",
    tag: "Sterilisation",
    description:
      "Mushroom Pasteurization Powder used to sterilise straw for 10 kg substrate batches. Mix with 150 litres of water + 1 kg Pasteurization Powder + 500 grams of dehydrated lime.",
    bullets: ["Treats up to 10 kg straw", "Recipe: 150 L water + 1 kg powder + 500 g lime"],
  },

  // ===== Mushroom Spawn =====
  {
    id: "spawn-florida-white",
    name: "Florida Spawn (White Oyster)",
    full_name: "Mushroom Spawn Florida · White Oyster",
    weight: "1 kg bag",
    price: 200,
    mrp: 250,
    rating: 4.9,
    reviewCount: 76,
    category: "Mushroom Spawn",
    storage: "Store at 18–24°C, away from sunlight. Use within 7 days.",
    image: "/img/spawn/florida-white.png",
    tag: "Bestseller",
    description:
      "Oyster Mushroom Spawn Florida (White Oyster) — best quality, high shelf-life, high yielding, fast mycelium growth with zero bacterial contamination. Produced in sterile conditions.",
    bullets: SPAWN_BENEFITS,
    tiers: spawnPricing(200),
  },
  {
    id: "spawn-sajor-caju-brown",
    name: "Sajor Caju Spawn (Brown Oyster)",
    full_name: "Mushroom Spawn Sajor Caju · Brown Oyster",
    weight: "1 kg bag",
    price: 200,
    mrp: 250,
    rating: 4.8,
    reviewCount: 54,
    category: "Mushroom Spawn",
    storage: "Store at 18–24°C, away from sunlight. Use within 7 days.",
    image: "/img/spawn/sajor-caju-brown.png",
    tag: "Bestseller",
    description:
      "Oyster Mushroom Spawn Sajor Caju (Brown Oyster) — best quality, high shelf-life, high yielding, fast mycelium growth with zero bacterial contamination. Produced in sterile conditions.",
    bullets: SPAWN_BENEFITS,
    tiers: spawnPricing(200),
  },
  {
    id: "spawn-djamore-pink",
    name: "Djamore Spawn (Pink Oyster)",
    full_name: "Mushroom Spawn Djamore · Pink Oyster",
    weight: "1 kg bag",
    price: 200,
    mrp: 250,
    rating: 4.9,
    reviewCount: 88,
    category: "Mushroom Spawn",
    storage: "Store at 18–24°C, away from sunlight. Use within 7 days.",
    image: "/img/spawn/djamore-pink.png",
    tag: "Most loved",
    description:
      "Oyster Mushroom Spawn Djamore (Pink Oyster) — best quality, high shelf-life, high yielding, fast mycelium growth with zero bacterial contamination. Produced in sterile conditions.",
    bullets: SPAWN_BENEFITS,
    tiers: spawnPricing(200),
  },
  {
    id: "spawn-hu-blue",
    name: "Hu Spawn (Blue Oyster)",
    full_name: "Mushroom Spawn Hu · Blue Oyster",
    weight: "1 kg bag",
    price: 200,
    mrp: 250,
    rating: 4.8,
    reviewCount: 42,
    category: "Mushroom Spawn",
    storage: "Store at 18–24°C, away from sunlight. Use within 7 days.",
    image: "/img/spawn/hu-blue.png",
    tag: "Rare variety",
    description:
      "Oyster Mushroom Spawn Hu (Blue Oyster) — best quality, high shelf-life, high yielding, fast mycelium growth with zero bacterial contamination. Produced in sterile conditions.",
    bullets: SPAWN_BENEFITS,
    tiers: spawnPricing(200),
  },
  {
    id: "spawn-milky",
    name: "Milky Mushroom Spawn",
    full_name: "Milky Mushroom Spawn · Calocybe Indica",
    weight: "1 kg bag",
    price: 250,
    mrp: 300,
    rating: 4.7,
    reviewCount: 31,
    category: "Mushroom Spawn",
    storage: "Store at 18–24°C, away from sunlight. Use within 7 days.",
    image: "/img/spawn/milky.png",
    tag: "Tropical",
    description:
      "Milky Mushroom Spawn Calocybe Indica — best quality milky mushroom spawn for tropical climates. High shelf-life, high yielding, fast mycelium growth with zero bacterial contamination. Produced in sterile conditions.",
    bullets: [
      "Best Quality Calocybe Indica Milky Mushroom Spawn",
      "High Shelf-Life",
      "High Yielding",
      "Fast Mycelium Growth",
      "No Bacterial Contamination",
      "Produced in Sterile Condition",
    ],
    tiers: [
      { range: "1 to 5 kg", price: 250, unit: "per kg" },
      { range: "5 to 10 kg", price: 200, unit: "per kg" },
      { range: "50 to 100 kg", price: 150, unit: "per kg" },
    ],
  },

  // ===== Mushroom Product =====
  {
    id: "dried-oyster",
    name: "Dried Oyster Mushroom",
    full_name: "Dried Oyster Mushroom · 50 g",
    weight: "50 g pouch",
    price: 150,
    mrp: 180,
    rating: 4.8,
    reviewCount: 73,
    category: "Mushroom Product",
    storage: "Store in a cool, dry place. Best within 24 months.",
    image: "/img/products/dried-oyster.png",
    tag: "Pantry staple",
    description:
      "Best quality dried oyster mushroom — sun dried, high shelf-life, produced in sterile conditions with zero bacterial contamination. Rich in protein, vitamin D and bone-health minerals.",
    bullets: ["Sun Dried", "High Shelf-Life", "No Bacterial Contamination", "Produced in Sterile Condition"],
  },
  {
    id: "dried-oyster-powder",
    name: "Dried Oyster Powder",
    full_name: "Dried Oyster Mushroom Powder · 50 g",
    weight: "50 g pouch",
    price: 150,
    mrp: 180,
    rating: 4.8,
    reviewCount: 64,
    category: "Mushroom Product",
    storage: "Reseal after use. Store in a cool, dry place. Best within 24 months.",
    image: "/img/products/dried-oyster-powder.png",
    tag: "Umami booster",
    description:
      "Best quality dried oyster mushroom powder — sun dried, finely milled, produced in sterile conditions with zero bacterial contamination. A natural vegetarian umami booster for dals, gravies, rotis and soups.",
    bullets: ["Sun Dried", "High Shelf-Life", "No Bacterial Contamination", "Produced in Sterile Condition"],
  },
  {
    id: "growing-kit-home",
    name: "Mushroom Growing Kit",
    full_name: "Mushroom Growing Kit · Home Kit",
    weight: "500 g substrate bag",
    price: 700,
    mrp: 850,
    rating: 4.9,
    reviewCount: 110,
    category: "Mushroom Product",
    storage: "Keep at 22–28°C in indirect light. Spray water 1–2 times a day.",
    image: "/img/products/growing-kit.png",
    tag: "Grow at home",
    description:
      "Mushroom growing kit to grow fresh oyster mushroom at home. Includes a white oyster mushroom straw bag with high quality mushroom mycelium and a water spray bottle. Harvest in around 15 days — just add water.",
    bullets: [
      "Pre-inoculated white oyster straw bag",
      "High quality mycelium",
      "Water spray bottle included",
      "Harvest in ~15 days",
    ],
  },
  {
    id: "mushroom-coffee",
    name: "Mushroom Coffee",
    full_name: "Mushroom Coffee · Ganoderma & Shitake",
    weight: "20 g pouch",
    price: 200,
    mrp: 240,
    rating: 4.7,
    reviewCount: 56,
    category: "Mushroom Product",
    storage: "Store in a cool, dry place. Reseal after use.",
    image: "/img/products/mushroom-coffee.png",
    tag: "Focus · Immunity · Energy",
    description:
      "Best quality mushroom coffee powder — 100% instant coffee enhanced with super food mushroom. Contains Shitake and Ganoderma mushroom for focus, immunity and energy.",
    bullets: [
      "100% instant coffee enhanced with super-food mushroom",
      "Contains Shitake & Ganoderma",
      "High shelf-life",
    ],
  },
  {
    id: "mushroom-papad",
    name: "Mushroom Papad",
    full_name: "Mushroom Masala Papad · 100 g",
    weight: "100 g pack",
    price: 110,
    mrp: 140,
    rating: 4.8,
    reviewCount: 49,
    category: "Mushroom Product",
    storage: "Store in a cool, dry place. Use best before 6 months.",
    image: "/img/products/mushroom-papad.png",
    tag: "Snack",
    description:
      "Mushroom Masala Papad — a nutritious snack made with moong & urad dal, mushroom powder, edible oil, asafoetida & spice. Good source of protein, fibre, iron and calcium. Low in calories & fat, high in protein, carbohydrates and dietary fibre.",
    bullets: [
      "Ingredients: Moong & Urad dal, mushroom powder, edible oil, asafoetida & spice",
      "High in protein & fibre",
      "Low in calories & fat",
    ],
  },
];

export const PRODUCT_CATEGORIES = ["All", "Mushroom Cultivation", "Mushroom Spawn", "Mushroom Product"];

export const GALLERY = [
  { src: "/img/products/dried-oyster.png", caption: "Dried Oyster Mushroom — 50 g pouch" },
  { src: "/img/products/dried-oyster-powder.png", caption: "Oyster Mushroom Powder — 50 g" },
  { src: "/img/products/growing-kit.png", caption: "Mushroom Growing Kit — harvest in 15 days" },
  { src: "/img/products/mushroom-coffee.png", caption: "Mushroom Coffee — Ganoderma & Shitake" },
  { src: "/img/products/mushroom-papad.png", caption: "Mushroom Masala Papad" },
  { src: "/img/spawn/florida-white.png", caption: "Florida Spawn — White Oyster" },
  { src: "/img/spawn/sajor-caju-brown.png", caption: "Sajor Caju Spawn — Brown Oyster" },
  { src: "/img/spawn/djamore-pink.png", caption: "Djamore Spawn — Pink Oyster" },
  { src: "/img/spawn/hu-blue.png", caption: "Hu Spawn — Blue Oyster" },
  { src: "/img/spawn/milky.png", caption: "Milky Mushroom Spawn — Calocybe Indica" },
  { src: "/img/cultivation/kit.png", caption: "Cultivation Kit — 10 bag starter" },
  { src: "/img/cultivation/pasteurization-powder.png", caption: "Pasteurization Powder — 1 kg" },
  { src: "/img/training/oyster-milky-paddy.jpg", caption: "Training programme — Oyster, Milky & Paddy" },
  { src: "/img/training/shitake-ganoderma.jpg", caption: "Medicinal training — Shitake & Ganoderma" },
  { src: "/img/training/cordyceps.jpg", caption: "Medicinal training — Cordyceps" },
];

// Training programmes (replaces single Workshop)
export const TRAININGS = [
  {
    id: "training-oyster-milky-paddy",
    title: "Oyster · Milky · Paddy Mushroom Training",
    subtitle: "Entrepreneur foundation programme",
    price: 6999,
    mrp: 8999,
    duration: "Full-day · on-site at Nagpur unit",
    badge: "Most enrolled",
    image: "/img/training/poster-oyster-milky-paddy.jpg",
    theme: "green",
    description:
      "A complete entrepreneur training programme covering oyster, milky and paddy mushroom cultivation — from substrate to spawning, crop management, harvesting, marketing strategy and unit economics. Certificate provided.",
    modules: [
      "Introduction to mushroom cultivation",
      "Different types of mushroom",
      "Oyster, milky & paddy cultivation",
      "Substrate preparation & sterilisation",
      "Spawning & bag filling (live demo)",
      "Crop management & harvesting",
      "Marketing strategy & economics",
      "Q&A · certificate · starter spawn",
    ],
  },
  {
    id: "training-shitake-ganoderma",
    title: "Medicinal Mushroom Training",
    subtitle: "Shitake & Ganoderma",
    price: 14999,
    mrp: 17999,
    duration: "2-day intensive · on-site",
    badge: "Specialist",
    image: "/img/training/poster-shitake-ganoderma.jpg",
    theme: "amber",
    description:
      "Hands-on training on cultivation of two of the most valuable medicinal mushrooms — Shitake and Ganoderma (Reishi). Includes substrate handling, sterile inoculation, fruiting management and downstream processing for value-added products.",
    modules: [
      "Medicinal mushroom market overview",
      "Shitake cultivation cycle",
      "Ganoderma (Reishi) cultivation cycle",
      "Sterile inoculation lab session",
      "Fruiting & humidity control",
      "Drying, milling & value-add",
      "Certificate · starter spawn",
    ],
  },
  {
    id: "training-cordyceps",
    title: "Medicinal Mushroom Training",
    subtitle: "Cordyceps cultivation",
    price: 24999,
    mrp: 29999,
    duration: "3-day intensive · lab + on-site",
    badge: "Advanced",
    image: "/img/training/poster-cordyceps.jpg",
    theme: "blue",
    description:
      "Our most advanced programme — Cordyceps militaris cultivation end-to-end. Substrate formulation, sterile lab work, growth chamber management, harvesting and extract processing. Best suited for serious entrepreneurs setting up a clean-room facility.",
    modules: [
      "Cordyceps market & medicinal value",
      "Substrate formulation",
      "Sterile lab technique",
      "Growth chamber set-up",
      "Climate control & monitoring",
      "Harvesting & drying",
      "Extract processing basics",
      "Certificate · starter culture",
    ],
  },
];

// News kept for reference / blog
export const NEWS = [
  {
    slug: "open-on-sundays",
    title: "We're now open Sundays in Manish Nagar",
    dek: "Fresh harvest pickup is available every Sunday between 9 am and noon.",
    category: "Announcement",
    date: "2026-01-12",
    readTime: "1 min read",
    cover: "https://customer-assets.emergentagent.com/job_organo-fresh/artifacts/yn62qasf_organo%20mushroom.jpg",
    body: [
      "Our Manish Nagar unit is now open on Sundays from 9 am to 12 pm for fresh harvest pickups, sample tastings, and a quick look inside the growing room.",
      "Walk-ins welcome. For a specific quantity, drop a WhatsApp by Friday evening and we'll have it ready in a marked tray.",
    ],
  },
  {
    slug: "training-batches-open",
    title: "New training batches open — entrepreneur and medicinal tracks",
    dek: "Three programme tiers: foundation, Shitake & Ganoderma, and Cordyceps. Limited seats.",
    category: "Training",
    date: "2026-01-08",
    readTime: "2 min read",
    cover: "https://customer-assets.emergentagent.com/job_organo-fresh/artifacts/0j0gbl8j_organo-mushroom-nagpur-food-product-manufacturers-t6ctyvcm3c.jpg",
    body: [
      "We've just opened seats across all three training tracks. The entrepreneur foundation (Oyster · Milky · Paddy) is the most enrolled, with two more advanced tracks for medicinal cultivation.",
      "Every batch is capped at 14 participants. Lunch and starter spawn included. Certificate provided on completion.",
    ],
  },
  {
    slug: "inside-new-spawning-room",
    title: "Inside our new spawning room",
    dek: "HEPA-filtered, UV-sterilised airflow; yield up ~14% on first batch.",
    category: "Behind the scenes",
    date: "2025-12-22",
    readTime: "3 min read",
    cover: "https://customer-assets.emergentagent.com/job_organo-fresh/artifacts/po6amlot_Mushroom%20Spawn%20%28Sojor%20Kaju%29.jpg",
    body: [
      "The spawning room is the most sensitive part of any mushroom farm. We took the room offline for two weeks and rebuilt it from scratch.",
      "First batch after rebuild: yield up ~14% and contamination zero across 80 jars.",
    ],
  },
];

export const TRUST_BADGES = [
  "FSSAI Certified",
  "Research Centre",
  "Training Provider",
  "Free Local Delivery",
  "Hand-harvested",
  "Central India Grown",
];

export const FEATURES = [
  { title: "Research & training centre", body: "Central India's turnkey solution for mushroom cultivation." },
  { title: "Sterile spawn production", body: "Spawn produced in lab conditions with zero bacterial contamination." },
  { title: "Cutting-edge technology", body: "From cultivation to packaging, modern methods at every step." },
  { title: "Certified & registered", body: "FSSAI Reg. 21250275000103. Every pack dated & traceable." },
];

export const CONTACT = {
  brand: "Organo Mushroom Research & Training Center",
  short: "Organo Mushroom",
  tagline: "Central India's Turnkey Solution Research Center for Mushroom Cultivation.",
  address: "55, Tukadoji Society, Prabhu Nagar, Manish Nagar Somalwada, Nagpur 440005",
  phones: ["77570 42529", "82088 05487"],
  email: "organomushroom@gmail.com",
  website: "https://organomushroom.com",
  logo: "https://customer-assets.emergentagent.com/job_organo-fresh/artifacts/wdyacygw_logo.avif",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  {
    label: "Shop",
    to: "/shop",
    children: [
      { label: "Mushroom Cultivation", to: "/shop?cat=Mushroom%20Cultivation" },
      { label: "Mushroom Spawn", to: "/shop?cat=Mushroom%20Spawn" },
      { label: "Mushroom Product", to: "/shop?cat=Mushroom%20Product" },
      { label: "Mushroom Training Program", to: "/workshop" },
    ],
  },
  {
    label: "Gallery",
    to: "/gallery",
    children: [
      { label: "Image", to: "/gallery?section=image" },
      { label: "Training Program", to: "/gallery?section=training" },
      { label: "MoU", to: "/gallery?section=mou" },
      { label: "Laboratory", to: "/gallery?section=laboratory" },
      { label: "Video", to: "/gallery?section=video" },
      { label: "Testimonial", to: "/gallery?section=testimonial" },
    ],
  },
  { label: "Awards", to: "/awards" },
  { label: "Contact", to: "/contact" },
];

// Gallery groupings for the 6 sub-sections.
export const GALLERY_SECTIONS = {
  image: {
    label: "Image",
    note: "Snapshots of our products, spawn bags and training posters.",
    items: [
      { src: "/img/products/dried-oyster.png", caption: "Dried Oyster Mushroom — 50 g pouch" },
      { src: "/img/products/dried-oyster-powder.png", caption: "Oyster Mushroom Powder — 50 g" },
      { src: "/img/products/growing-kit.png", caption: "Mushroom Growing Kit" },
      { src: "/img/products/mushroom-coffee.png", caption: "Mushroom Coffee" },
      { src: "/img/products/mushroom-papad.png", caption: "Mushroom Masala Papad" },
      { src: "/img/spawn/florida-white.png", caption: "Florida Spawn — White Oyster" },
      { src: "/img/spawn/sajor-caju-brown.png", caption: "Sajor Caju — Brown Oyster" },
      { src: "/img/spawn/djamore-pink.png", caption: "Djamore — Pink Oyster" },
      { src: "/img/spawn/hu-blue.png", caption: "Hu — Blue Oyster" },
      { src: "/img/spawn/milky.png", caption: "Milky Mushroom Spawn" },
      { src: "/img/cultivation/kit.png", caption: "Cultivation Kit — 10 bag starter" },
      { src: "/img/cultivation/pasteurization-powder.png", caption: "Pasteurization Powder 1 kg" },
    ],
  },
  training: {
    label: "Training Program",
    note: "Posters and moments from our entrepreneur and medicinal training batches.",
    items: [
      { src: "/img/training/poster-oyster-milky-paddy.jpg", caption: "Oyster · Milky · Paddy programme" },
      { src: "/img/training/poster-shitake-ganoderma.jpg", caption: "Medicinal — Shitake & Ganoderma" },
      { src: "/img/training/poster-cordyceps.jpg", caption: "Medicinal — Cordyceps" },
    ],
  },
  mou: {
    label: "MoU",
    note: "MoU signings with institutions and state bodies. Photos coming soon.",
    items: [],
  },
  laboratory: {
    label: "Laboratory",
    note: "Inside our sterile spawn and R&D lab. Photos coming soon.",
    items: [],
  },
  video: {
    label: "Video",
    note: "Step-by-step cultivation walkthroughs. Videos coming soon.",
    items: [],
  },
  testimonial: {
    label: "Testimonial",
    note: "Stories from our training alumni. Photos coming soon.",
    items: [],
  },
};

export const ABOUT_PILLARS = [
  { label: "Training Programs", note: "Entrepreneur + medicinal tracks" },
  { label: "MoU Partnerships", note: "Institutions & state bodies" },
  { label: "Research Laboratory", note: "Sterile spawn & R&D" },
  { label: "Video Library", note: "Step-by-step cultivation" },
  { label: "Testimonials", note: "From our alumni" },
];

export const PROMOS = [
  { icon: "🎓", text: "New training batches now open · entrepreneur & medicinal tracks" },
  { icon: "🚚", text: "Free Nagpur delivery on orders placed before noon" },
  { icon: "✦", text: "Use code FRESH10 for 10% off your first basket" },
  { icon: "🌱", text: "FSSAI certified · sterile spawn · turnkey solutions" },
];

export const COUPONS = {
  FRESH10: { type: "percent", value: 10, label: "10% off entire basket" },
  TRAIN500: { type: "flat", value: 500, label: "₹500 off any training seat" },
  ORGANO50: { type: "flat", value: 50, label: "₹50 off above ₹500" },
};

export const ACCREDITATIONS = [
  { name: "FSSAI", note: "Reg. 21250275000103" },
  { name: "MSME", note: "Udyam registered" },
  { name: "Research Centre", note: "Central India" },
  { name: "AGMARK quality", note: "Quality graded" },
  { name: "Make in India", note: "Proudly local" },
  { name: "Training Provider", note: "Govt. recognised" },
];

export const REVIEWS = {
  "growing-kit-home": [
    { name: "Sneha R.", rating: 5, date: "2026-01-10", title: "First grow success", body: "Got my first harvest in 14 days — pink oysters! The instructions are spot on." },
    { name: "Ishaan V.", rating: 5, date: "2025-12-28", title: "Great gift", body: "Gifted to my dad. He's now obsessed and asking for the training programme." },
  ],
  "dried-oyster": [
    { name: "Aarya P.", rating: 5, date: "2026-01-08", title: "Better than the market", body: "Reconstitutes beautifully — way more flavour than the imported dried mushrooms." },
  ],
  "dried-oyster-powder": [
    { name: "Tanvi J.", rating: 5, date: "2026-01-03", title: "Umami in a pouch", body: "I use it in dals, rasam, even khichdi. Subtle but addictive." },
  ],
  "mushroom-coffee": [
    { name: "Kabir M.", rating: 5, date: "2025-12-26", title: "Smooth + focused", body: "Real mushroom notes, not earthy in a weird way. Solid morning cup." },
  ],
  "mushroom-papad": [
    { name: "Priya M.", rating: 5, date: "2026-01-11", title: "Crispy and protein-rich", body: "Family of four — finished in one meal. Will reorder regularly." },
  ],
  "spawn-djamore-pink": [
    { name: "Akash G.", rating: 5, date: "2026-01-06", title: "Strong mycelium growth", body: "Colonised my bags in 12 days flat. Zero contamination." },
  ],
  "spawn-florida-white": [
    { name: "Devika S.", rating: 5, date: "2025-12-20", title: "Reliable spawn", body: "Already on my third order. Consistent quality every time." },
  ],
  "training-oyster-milky-paddy": [
    { name: "Rahul C.", rating: 5, date: "2026-01-09", title: "Best day spent", body: "Walked in clueless, walked out ready to set up my own unit." },
    { name: "Yash P.", rating: 5, date: "2025-12-23", title: "Way more than ₹6,999 worth", body: "Lunch, certificate, starter spawn — and a WhatsApp group with the cohort." },
  ],
};

// Awards / press recognitions (data shape; images coming from user)
export const AWARDS = [
  { title: "Award placeholder 1", body: "Image and details to be added.", year: "2024" },
  { title: "Award placeholder 2", body: "Image and details to be added.", year: "2024" },
  { title: "Award placeholder 3", body: "Image and details to be added.", year: "2025" },
  { title: "Award placeholder 4", body: "Image and details to be added.", year: "2025" },
];
